import * as roles from '@purple/match-graphql-schema/lib/schema/support/roles'; // eslint-disable-line import/no-extraneous-dependencies

export const LOGIN_USER_NEW_PASSWORD_REQUIRED = 'LOGIN_USER_NEW_PASSWORD_REQUIRED';
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_CLEAR_ERRORS = 'LOGIN_CLEAR_ERRORS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const ADMIN_ROLE = 'administrator';
export const RECRUITER_ROLE = 'recruiter';
export const COORDINATOR_ROLE = 'coordinator';
export const DIRECTOR_ROLE = 'director';
export const PUBLISHING_ROLE = 'publishing';
export const COMMUNITY_ROLE = 'community';
export const REPORTS_ROLE = 'reports';

export const HUBS_SUBSCRIPTION = 'HUBPAGE';
export const COMMMUNITY_SUBSCRIPTION = 'COMMUNITY';
export const MATCHING_SUBSCRIPTION = 'MATCHING'; // This is the Awareness Subscription
export const REP_VISITS_SUBSCRIPTION = 'REPVISITS';
export const AM_PLUS_SUBSCRIPTION = 'AMPLUS';
export const ADV_AWARENESS_SUBSCRIPTION = 'ADVANCEDAWARENESS';
export const SCHOLARSHIPS_SUBSCRIPTION = 'SCHOLARSHIPS';
export const CONNECTION_SUBSCRIPTION = 'CONNECTION';
export const CAMINO_SUBSCRIPTION = 'CAMINO';
export const INLINE_MANUAL = 'INLINE_MANUAL';
export const COMMUNITY_SERVERLESS = 'COMMUNITYSERVERLESS';
export const DISABLE_LEGACY_COMMUNITY = 'DISABLE_LEGACY_COMMUNITY';
export const COMMON_APP_DEADLINES = 'release.int.hem.commonAppDeadlines';
export const HEM_IMAGE_INSTRUCTIONS_FEATURE = 'feature.intersectHE.imageInstructionsHEM';
export const FEATURE_MATCH_HUBS_INTERSECT_YOUVISITTOURS = 'feature.match.hubs.intersect.YouVisitTours';
export const FEATURE_MATCH_HUBS_INTERSECT_YOUVISITTOURS_IPEDSCODE = 'feature.match.hubs.intersect.YouVisitTours.ipedscode';

export const PHEM_SUBSCRIPTIONS = [MATCHING_SUBSCRIPTION, HUBS_SUBSCRIPTION, CAMINO_SUBSCRIPTION];

export const IMPERSONATOR_SUPER_ADMIN_ROLE = roles.SUPER_ADMIN_ROLE;

export const APP_ROLES = [
  ADMIN_ROLE, PUBLISHING_ROLE, COMMUNITY_ROLE,
];

export const REPVISITS_LOOKING_FOR_YOU_COUNT = 'REPVISITS_LOOKING_FOR_YOU_COUNT';
export const REPVISITS_RSVP_COUNTER = 'REPVISITS_RSVP_COUNTER';
export const CAMINO_EVENTS_HE = 'CAMINO_EVENTS_HE';
export const CAMINO_HEM_TRANSFER_INFO = 'CAMINO_HEM_TRANSFERINFO';

export const ADD_JOB_TOPIC_FIELD = 'feature.intersectHE.upgradeForm.addJobTopicField';
export const MODIFY_MESSAGE_FIELD = 'feature.intersectHE.upgradeForm.modifyMessageField';
export const REMOVE_DIVERSITY_FILTERS = 'feature.intersectHE.diversity.removeAllFilters';
